






import { Component, Vue } from "vue-property-decorator";
import LoginForm from "../components/LoginForm.vue";

@Component({
  components: { LoginForm }
})
export default class LoginRequest extends Vue {}
